import { Canvas } from '@react-three/fiber';
import { Suspense } from 'react';
import Engineer from '../components/Engineer';

const ThankYou = () => {
  return (
    <div className='background'>
      <div className='line-overlay'></div>
      <div className='left-content'>
        <img src="/neonlogo.png" alt="Price level" style={{ width: '295px', transform: 'rotate(-9deg)'}} />
        
        <div className="thank-you-container flip-in-transition">
            <h2>Registration complete!</h2>
            <p>Thank you for registering.</p>
            <p style={{ fontSize: "1.2em", fontWeight: "bold", margin: "20px 0" }}>
                Come to our booth to play and win some goodies!
            </p>
        </div>
      </div>
      
      <Canvas style={{width: '100vw', height: '100vw', position: 'absolute', top: '0', zIndex: '-1'}}>
        <Suspense>
          <ambientLight />
          <Engineer />
          <directionalLight
            castShadow
            position={[5, 15, 10]}
            intensity={1.5}
            shadow-mapSize-width={1024}
            shadow-mapSize-height={1024}
            shadow-camera-near={1}
            shadow-camera-far={50}
            shadow-camera-left={-10}
            shadow-camera-right={10}
            shadow-camera-top={10}
            shadow-camera-bottom={-10}
          />
        </Suspense>
      </Canvas>
    </div>
  );
};

export default ThankYou;
